import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import _ from 'lodash';
import { $definitions, } from 'ziphy-web-shared/basic/entities/notes/definitions';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { Input } from 'ziphy-web-shared/basic/lib/forms/fields';
import { ConnectedGroup, ToggleButton } from 'ziphy-web-shared/basic/lib/simple';
import { $loader } from 'ziphy-web-shared/basic/utils';
import styles from './BlockReviewOfSystems.module.scss';
const BlockReviewOfSystemsButtons = ({ $element, definition }) => {
    const { t } = useTranslation();
    const form = $element.builder.form;
    const field = form.field(definition.code, {});
    const selects = useMemo(() => {
        const result = { positive: [], negative: [] };
        const fullCode = 'ros_' + definition.code;
        const selects = Object.values($definitions.selects.valuesMap(fullCode));
        selects.forEach((item) => {
            if (item.code === 'other') {
                result.positive.push({
                    id: item.code,
                    text: item.title,
                    hasExtraField: true,
                });
                return;
            }
            const selects = Object.values($definitions.selects.valuesMap(fullCode + '_' + item.code));
            selects.forEach((subItem) => {
                if (subItem.code === 'yes') {
                    result.positive.push({ id: item.code, text: subItem.title });
                }
                else if (subItem.code === 'no') {
                    result.negative.push({ id: item.code, text: subItem.title });
                }
            });
        });
        return result;
    }, [definition.code]);
    const setAllAsNormal = useCallback(() => {
        const result = {};
        selects.negative.forEach((item) => {
            result[item.id] = false;
        });
        field.onChange(result);
    }, [selects]);
    useEffect(() => {
        const listenEventName = `${$element.builder.form.id}_set_all_as_normal`;
        const ids = $loader.subscribe(listenEventName, setAllAsNormal);
        return () => $loader.unsubscribe(listenEventName, ids);
    }, [$element.builder.form.id, setAllAsNormal]);
    return (_jsxs("div", Object.assign({ className: styles.buttons }, { children: [_jsx("div", Object.assign({ className: styles.buttonsGroup }, { children: selects.negative.map((item) => (_jsx(ToggleButton, { mode: ['green', 'xxs'], checkbox: { position: 'none' }, label: item.text, selected: field.value[item.id] === false, onClick: () => {
                        if (field.value[item.id] === false) {
                            field.onChange(_.omit(field.value, [item.id]));
                        }
                        else {
                            field.onChange(Object.assign(Object.assign({}, field.value), { [item.id]: false }));
                        }
                    }, className: styles.buttonsGroupButton, invalid: field.isInvalid && typeof field.value[item.id] !== 'boolean' }, item.id))) })), _jsx("div", Object.assign({ className: styles.buttonsGroup }, { children: selects.positive.map((item) => {
                    return item.hasExtraField ? (_jsx(ConnectedGroup, { styleSet: ['resetCorners'], renderItems: [
                            ({ getClass }) => {
                                return (_jsx(ToggleButton, { mode: ['red', 'xxs'], checkbox: { position: 'none' }, label: item.text, selected: typeof field.value[item.id] === 'string', onClick: () => {
                                        if (typeof field.value[item.id] === 'string') {
                                            field.onChange(_.omit(field.value, [item.id]));
                                        }
                                        else {
                                            field.onChange(Object.assign(Object.assign({}, field.value), { [item.id]: '' }));
                                        }
                                    }, className: classNames(getClass(), styles.buttonsGroupButton), invalid: field.isInvalid &&
                                        typeof field.value[item.id] === 'string' &&
                                        field.value[item.id].trim() === '' }, item.id));
                            },
                            ({ getClass }) => {
                                return typeof field.value[item.id] === 'string' ? (_jsx(Input, { field: {
                                        value: field.value[item.id] || '',
                                        onChange: (value) => {
                                            field.onChange(Object.assign(Object.assign({}, field.value), { [item.id]: value }));
                                        },
                                        isInvalid: field.isInvalid && field.value[item.id].trim() === '',
                                    }, mode: ['xxs'], className: styles.buttonsGroupInput, innerClassName: classNames(getClass(), styles.buttonsGroupInputInner) })) : null;
                            },
                        ] }, item.id)) : (_jsx(ToggleButton, { mode: ['red', 'xxs'], checkbox: { position: 'none' }, label: item.text, selected: field.value[item.id] === true, onClick: () => {
                            if (field.value[item.id] === true) {
                                field.onChange(_.omit(field.value, [item.id]));
                            }
                            else {
                                field.onChange(Object.assign(Object.assign({}, field.value), { [item.id]: true }));
                            }
                        }, className: styles.buttonsGroupButton, invalid: field.isInvalid && typeof field.value[item.id] !== 'boolean' }, item.id));
                }) })), _jsxs("div", Object.assign({ className: classNames(styles.buttonsGroup, styles.buttonsGroupActions) }, { children: [_jsx(Button, Object.assign({ className: styles.button, mode: ['xxs', 'white'], onClick: () => {
                            field.onChange({});
                        } }, { children: t('label.clear') })), _jsx(Button, Object.assign({ className: styles.button, mode: ['xxs', 'white'], onClick: setAllAsNormal }, { children: t('label.normal') }))] }))] })));
};
export default observer(BlockReviewOfSystemsButtons);
